import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BillItemPendingModel, PaymentBillItemPendingModel } from '@data-layer/models/payments';
import { CompanyModel } from '@data-layer/models/companies';
import { enumCompanyPaymentType } from '@data-layer/enums/companies';
import { CompaniesService } from '@services/companies.service';
import { switchMap, take } from 'rxjs/operators';
import { MarineInsuranceFacade, MarineInsuranceState } from '@shared/marine-insurance-shared/services';

@Component({
  selector: 'app-marine-insurance-payment-button',
  templateUrl: './marine-insurance-payment-button.component.html',
  styleUrls: ['./marine-insurance-payment-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarineInsurancePaymentButtonComponent {
  @Input() public referenceNumber: string;
  @Input() public isPaymentAvailable: boolean;
  @Input() public isCouponAvailable: boolean;
  @Input() public isDesktop: boolean;
  @Input() public pendingBills: PaymentBillItemPendingModel;
  @Input() public couponName: string;
  @Input() public id: string;
  @Input() public isDisabled: boolean;

  public company: CompanyModel;

  constructor(
    private marineInsuranceFacade: MarineInsuranceFacade,
    private companiesService: CompaniesService,
    private marineInsuranceState: MarineInsuranceState,
  ) {}

  public confirmPayment(): void {
    const companyId: number = this.companiesService.getCompany()?.id;

    this.marineInsuranceFacade
      .createBill(companyId, [this.referenceNumber], null, null, null, null)
      .pipe(
        switchMap(() => this.marineInsuranceFacade.getPendingBills(companyId, [this.referenceNumber], null, null)),
        take(1),
      )
      .subscribe((bills: PaymentBillItemPendingModel) => {
        this.marineInsuranceState.saveBillsData(bills);
      });
  }

  public get isHasInstantPayment(): boolean {
    return (this.pendingBills?.items || []).some((bill: BillItemPendingModel) => bill.paymentType === enumCompanyPaymentType.INSTANT);
  }
}
